export default __webpack_public_path__ + "static/media/green-marker-icon.2fe82e7c.png";